// extracted by mini-css-extract-plugin
module.exports = {"Default":"withNotification_Default__1o6tQ","Body":"withNotification_Body__3FDrZ"};